<template>
  <v-row class="mx-1">
    <AdministratorCallsList :selected-administrator-id="administratorId"
                            v-model="isAdminCallsListDialogVisible" />
    <EditAdministratorCallConfig v-model="isEditVirtualCallCellphoneDialogVisible"
                                 :selected-administrator-id="administratorId" />
    <NewEditAdministrator v-model="isAddEditAdministratorDialog"
                          :administrator="selectedAdministrator"/>
    <invite-administrator v-model="showInviteAdministratorDialog"
                          headerColor="kbLightBlue"
                          type="administrador">
    </invite-administrator>

    <delete-administrator v-model="showUninviteAdministratorDialog"
                          :userId="administratorId"
                          @clearAdministratorId="clearAdministratorId()"/>

    <v-col cols="12" class="d-flex align-end justify-space-between flex-wrap pt-0">
      <v-text-field append-icon="mdi-magnify"
                    class="mr-3"
                    color="kbDarkBlueText"
                    hide-details
                    :placeholder="$t('general.search')"
                    v-model="searchValue"/>

      <v-btn @click="showAddEditAdministratorDialog()"
             class="mr-2"
             color="mainButtons"
             outlined>
        {{$t('general.addAdministrator')}}
      </v-btn>
      <v-btn color="mainButtons"
             dark
             @click="showInviteAdministratorDialog = true">
        {{$t('general.inviteAdministrator')}}
      </v-btn>
    </v-col>

    <v-col cols="12" class="pb-0 text-h6">
      <v-data-table :headers="headers"
                    fixed-header
                    :height="dataTableHeight"
                    :items="administrators"
                    class="elevation-2"
                    :loading="loadingUsersCompany"
                    :options.sync="pagination"
                    :footer-props="{
                            'items-per-page-text': $t('general.administratorsPerPage'),
                            'items-per-page-options': [50, 100, 200]
                          }"
                    :server-items-length="totalUsersCompany"
                    :must-sort="false">
        <template v-slot:item="{ item }">
          <tr>
            <td class="font-weight-bold text-capitalize">
              {{ item.fullName ? item.fullName.toLowerCase() : $t('general.noName') }}
            </td>
            <td>{{ item.email || $t('general.noEmail')}}</td>
            <td>{{ item.phone || $t('general.noPhone')}}</td>
            <td class="text-center">{{ item.isInvited ? $t('general.yes') : $t('general.no') }}</td>
            <td class="text-center">
              <v-btn icon @click="showAddEditAdministratorDialog(item)" color="kbDarkBlueText" text>
                <v-icon>mdi-eye</v-icon>
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon
                         color="kbGreen"
                         @click="showEditVirtualCallCellphoneDialog(item.userId)"
                         text
                         v-on="on">
                    <v-icon>mdi-cellphone-cog</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.setAdministratorCallConfig') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon
                         color="kbGreen"
                         @click="showAdministratorCallsDialog(item.userId)"
                         text
                         v-on="on">
                    <v-icon>mdi-phone-log</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.administratorCalls') }}</span>
              </v-tooltip>
              <v-btn icon @click="showDeleteAdministratorDialog(item.UUID)" color="kbRed" text>
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          <v-row>
            <v-col class="text-center" cols="12" v-if="loadingUsersCompany">
              {{$t('general.loadingAdministrators')}}
            </v-col>
            <v-col cols="12" class="red--text text-center" v-else>
              {{$t('general.noAdministratorsRegistered')}}
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import InviteAdministrator from '@/pages/App/People/dialogs/InviteAdministrator.vue'
import EditAdministratorCallConfig from './dialogs/EditAdministratorCallConfig'
import NewEditAdministrator from './dialogs/NewEditAdministrator'
import DeleteAdministrator from './dialogs/DeleteAdministrator'
import AdministratorCallsList from './dialogs/AdministratorCallsList'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
export default {
  components: {
    AdministratorCallsList,
    EditAdministratorCallConfig,
    DeleteAdministrator,
    NewEditAdministrator,
    InviteAdministrator
  },
  computed: {
    ...mapState({
      loadingUsersCompany: state => state.companies.loadingUsersCompany,
      paginationUsersCompany: state => state.companies.paginationUsersCompany,
      totalUsersCompany: state => state.companies.totalUsersCompany
    }),
    ...mapGetters([
      'companyUuid',
      'administrators'
    ]),
    filteredItems () {
      if (this.searchValue) {
        return this.administrators.filter(item =>
          item.name.toLowerCase().includes(this.searchValue.toLowerCase()) ||
            item.email.toLowerCase().includes(this.searchValue.toLowerCase()) ||
            item.phone.toLowerCase().includes(this.searchValue.toLowerCase()))
      }
      return this.administrators
    },
    headers () {
      return [
        { text: this.$t('general.fullName'), value: 'fullName' },
        { text: this.$t('general.email'), value: 'email' },
        { text: this.$t('general.phone'), value: 'UUID' },
        { text: this.$t('general.invited'), align: 'center', value: 'auths' },
        { text: this.$tc('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  data () {
    return {
      pagination: {},
      administratorId: '',
      isAdminCallsListDialogVisible: false,
      isAddEditAdministratorDialog: false,
      isEditVirtualCallCellphoneDialogVisible: false,
      searchValue: '',
      showInviteAdministratorDialog: false,
      showUninviteAdministratorDialog: false,
      selectedAdministrator: {}
    }
  },
  methods: {
    getAdministrators () {
      this.$store.commit('SET_PAGINATION_USERS_COMPANY', this.pagination)
      const searchValue = this.searchValue
      this.$store.dispatch('getAdministrators', searchValue)
    },
    showAdministratorCallsDialog (userId) {
      this.administratorId = userId
      this.isAdminCallsListDialogVisible = true
    },
    showEditVirtualCallCellphoneDialog (userId) {
      this.administratorId = userId
      this.isEditVirtualCallCellphoneDialogVisible = true
    },
    showDeleteAdministratorDialog (userId) {
      this.administratorId = userId
      this.showUninviteAdministratorDialog = true
    },
    showAddEditAdministratorDialog (administrator = {}) {
      this.selectedAdministrator = administrator
      this.isAddEditAdministratorDialog = true
    },
    clearAdministratorId () {
      this.administratorId = ''
    }
  },
  mixins: [ModuleTableHeight],
  watch: {
    pagination: {
      handler () {
        this.getAdministrators()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    searchValue () {
      this.pagination.page = 1
      this.getAdministrators()
    },
    isAddEditAdministratorDialog (value) {
      if (!value) this.selectedAdministrator = {}
    }
  }
}
</script>
